import request from '@/utils/request'

export function stationList (query) {
  return request({
    url: '/api/station/list',
    method: 'post',
    params: query
  })
}

export function listFp (data) {
  return request({
    url: '/api/station/listFp',
    method: 'post',
    params: data
  })
}

export function listTank (data) {
  return request({
    url: '/api/station/listTank',
    method: 'post',
    data
  })
}

export function listStationSimple (data) {
  return request({
    url: '/api/station/listSample',
    method: 'post',
    data
  })
}

export function getBussinessInfo () {
  return request({
    url: '/api/data/bussinessInfo',
    method: 'post'
  })
}

export function listVisibleVersion (data) {
  return request({
    url: '/api/station/listVisibleVersion',
    method: 'post',
    data
  })
}

export function updateFpVersion (data) {
  return request({
    url: '/api/station/updateFpVersion',
    method: 'post',
    data
  })
}

export function listStationOfType (data) {
  return request({
    url: '/api/station/listStationOfType',
    method: 'post',
    data
  })
}
